import { makeAutoObservable, runInAction } from 'mobx';
import { getNotificationList, ackSelectedNotification } from '@/api';


class MessageCenter {
  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  displayList = [];
  onlyUnread = false;
  tableLoading = false;
  fromCall = '';

  changeFromCall(id) {
    this.fromCall = id;
  }

  async setOnlyUnread(onlyUnread) {
    runInAction(() => {
      this.onlyUnread = onlyUnread;
    });
  }

  //获取通知列表
  async getNotificationList(params) {
    runInAction(() => {
      this.tableLoading = true;
    });
    let res;
    try {
      res = await getNotificationList(params);
      if (res && res.data && res.code === 200) {
        runInAction(() => {
          this.displayList = res.data;

        });
      }
    } catch (err) {}
    finally {
      runInAction(() => {
        this.tableLoading = false;
      });
    }
  }

  async messageSelectedRead(selectedIds) {
    let res;
    try {
      res = await ackSelectedNotification(selectedIds);
    } catch (err) {}
    return res;
  }
}

export default new MessageCenter();
